module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_05@2x-e0ca1b1980e063cc452772e5180ccd39.jpg";